<template>
  <div>
    <div class="d-flex align-items-start">
      <validation-provider
        class="w-100"
        :ref="inputId"
        :name="inputName"
        :rules="inputValidationRules"
        v-slot="validationContext">
        <b-form-group
          class="form-input-wrapper"
          :label="customPlaceholder ? customPlaceholder : inputName"
          :label-for="inputId + 'Id'"
          :label-class="(!!model) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
          :invalid-feedback="validationContext.errors[0]"
        >
          <b-input-group>
            <b-form-input
              :disabled="disabled"
              :id="inputId + 'Id'"
              :class="{ 'form-input': true, 'filled-field': (!!model), 'required-field': (!(!!model) && required), inputId: true }"
              v-model="model"
              :placeholder="customPlaceholder ? customPlaceholder : inputName"
              @focus="loadData"
              @input="loadData"
              @change="updateIdbData"
              :state="getValidationState(validationContext)"
              trim
            ></b-form-input>
            <b-input-group-append v-if="edited">
              <b-button size="sm" @click="openDescriptionModal" squared variant="outline-success">
                <font-awesome-icon icon="fa-solid fa-pencil" />
              </b-button>
            </b-input-group-append>
            <span class="custom-invalid-feedback">{{ validationContext.errors[0] }}</span>
          </b-input-group>
          <div v-if="(type === 'multiple') || (type === 'single')" class="tooltips-wrapper">
            <font-awesome-icon @click="closeRef" icon="fa-solid fa-xmark" size="sm" />
            <b-table
              v-if="items && items.length && (targetInput === inputId) && (type === 'single')"
              :id="inputId"
              class="data_table_nsi"
              :items="items"
              :fields="inputFields"
              @row-clicked="selectItem"
              hover
              small
            ></b-table>
            <b-form-checkbox-group
              v-if="type === 'multiple'"
              id="checkbox-group-1"
              v-model="modelCheckbox"
              name="flavour-1"
            >
              <b-table
                v-if="items && items.length && (targetInput === inputId)"
                :id="inputId"
                class="data_table_nsi"
                :items="items"
                :fields="inputFields"
                hover
                small
              >
                <template v-slot:[`cell(${selectByProperty})`]="data">
                  <b-form-checkbox :value="data.item[selectByProperty]">{{ data.item[selectByProperty] }}</b-form-checkbox>
                </template>
              </b-table>
            </b-form-checkbox-group>
          </div>
        </b-form-group>
      </validation-provider>
      <span v-if="create" title="Сохранить в справочник" v-b-tooltip.hover>
        <b-button
          @click="addToCatalog"
          class="ml-2"
          size="sm"
          variant="outline-success"
          :disabled="disabled"
          squared>
          <font-awesome-icon icon="fa-solid fa-floppy-disk" />
        </b-button>
      </span>
    </div>
    <b-modal
      v-if="edited"
      ref="add-description"
      size="lg"
      :title="inputName"
      @hidden="changeDescription"
      ok-only
      no-stacking>
      <b-form-group
        id="input-group-1"
        label-for="AddDescription"
        label-class="form-label">
        <b-form-textarea
          id="AddDescription"
          v-model="model"
          rows="12"
          :disabled="disabled"
          @change="updateIdbData"
          trim
        ></b-form-textarea>
      </b-form-group>
      <template #modal-footer="{ ok }">
        <b-button size="sm" variant="success" squared @click="ok()">Сохранить</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { addKeyboardRefsNavigationMixin } from './mixins/addKeyboardRefsNavigationMixin'
  export default {
    name: "CustomInput",
    mixins: [addKeyboardRefsNavigationMixin],
    props: {
      type: {
        default: 'single',
        type: String
      },
      inputId: {
        default: null,
        type: String
      },
      inputName: {
        default: null,
        type: String
      },
      targetInput: {
        default: null,
        type: String
      },
      customPlaceholder: {
        default: null,
        type: String
      },
      index: {
        default: null,
        type: Number
      },
      parent: {
        default: null,
        type: String
      },
      inputValidationRules: {
        default: null,
        type: Object
      },
      inputItems: {
        default: null,
        type: Array
      },
      inputFields: {
        default: null,
        type: Array
      },
      inputRelatedFields: {
        default: null,
        type: Array
      },
      createFields: {
        default: null,
        type: Array
      },
      getData: {
        type: Function
      },
      postData: {
        type: Function
      },
      selectByProperty: {
        default: null,
        type: String
      },
      loadOnFocus: {
        default: false,
        type: Boolean
      },
      disabled: {
        default: false,
        type: Boolean
      },
      required: {
        default: false,
        type: Boolean
      },
      edited: {
        default: false,
        type: Boolean
      },
      create: {
        default: false,
        type: Boolean
      },
      delay: {
        default: null,
        type: Number
      },
      query: {
        default: null,
        type: String
      },
      select: {
        default: null,
        type: String
      }
    },
    data () {
      return {
        model: null,
        modelCheckbox: [],
        items: [],
        keyDownListener: null,
        keyPressCounter: -1,
        recursiveKeyDownListener: null,
        keyDownListenerInterval: null
      }
    },
    watch: {
      inputItems (val) {
        this.changeItems(val)
      },
      modelCheckbox (val) {
        if (val && (val.length > 0)) {
          let selectedItems = []
          for (let i = 0; i < val.length; i++) {
            const selectedItem = this.inputItems.find((item) => {
              return item[`${this.selectByProperty}`] === val[i]
            })
            if (selectedItem !== undefined) {
              selectedItems.push(selectedItem)
            }
          }
          this.$emit('setForm', { fieldName: this.inputId, item: selectedItems })
          if (val && (val.length > 0)) {
            this.model = val.join(', ')
          } else {
            this.model = null
          }
        }
      },
      items (val) {
        if (val && (val.length === 0)) {
          document.removeEventListener('keydown', this.recursiveKeyDownListener, false)
          clearInterval(this.keyDownListenerInterval)
          this.$emit('setRefVisible', false)
        }
      }
    },
    mounted () {},
    methods: {
      changeItems (val) {
        this.items = val
        if (this.items) {
          this.items.map((item) => {
            const keys = Object.keys(item)
            for (let i = 0; i < keys.length; i++) {
              if (/^\d{4}-\d{2}-\d{2}$/.test(item[keys[i]])) {
                let date = item[keys[i]].split('-')
                date = date[2] + '.' + date[1] + '.' + date[0]
                item[keys[i]] = date
              }
            }
            return item
          })
        }
      },
      openDescriptionModal () {
        this.$refs['add-description'].show()
      },
      changeDescription () {
        this.$emit('setForm', { fieldName: this.inputId, item: this.model, index: this.index, parent: this.parent })
      },
      getValidationState ({ dirty, validated, valid = null }) {
        return dirty || validated ? valid : null
      },
      loadData (event) {
        this.$emit('closeRefs')
        this.$emit('setTargetInput', this.inputId)

        if ((event.type === 'focus') && this.loadOnFocus) {
          this.getData().then(
            () => {
              if (this.items.length === 0) {
                this.changeItems(this.inputItems)
              }
              this.$emit('setRefVisible', true)
              this.addKeyboardRefsNavigation(this.inputId)
            }
          )
        } else if (event === '') {
          this.model = null
          this.$emit('setForm', { fieldName: this.inputId, item: null, index: this.index, parent: this.parent })
        } else {
          if (this.delay) {
            if (event.length >= this.delay) {
              const param = this.query ? { [this.query]: event } : event
              this.getData(param).then(
                () => {
                  this.$emit('setRefVisible', true)
                  this.addKeyboardRefsNavigation(this.inputId)
                }
              )
            }
          }
        }
      },
      closeRef () {
        this.items = []
      },
      selectItem (item) {
        if (this.inputRelatedFields) {
          const keys = Object.keys(item)
          for (let i = 0; i < keys.length; i++) {
            if (/^\d{2}\.\d{2}\.\d{4}$/.test(item[keys[i]])) {
              let date = item[keys[i]].split('.')
              date = date[2] + '-' + date[1] + '-' + date[0]
              item[keys[i]] = date
            }
          }
          this.$emit('setRelatedFields', { relatedFields: this.inputRelatedFields, item: item, index: this.index, parent: this.parent })
        }
        if (this.select) {
          this.model = item[this.select]
          if (/^\d{2}\.\d{2}\.\d{4}$/.test(item[this.select])) {
            let date = item[this.select].split('.')
            date = date[2] + '-' + date[1] + '-' + date[0]
            item[this.select] = date
          }
          // this.$emit('setForm', { fieldName: this.inputId, item: item[this.select], index: this.index, parent: this.parent })
        } else {
          this.model = item[this.inputFields[0].key]
          const keys = Object.keys(item)
          for (let i = 0; i < keys.length; i++) {
            if (/^\d{2}\.\d{2}\.\d{4}$/.test(item[keys[i]])) {
              let date = item[keys[i]].split('.')
              date = date[2] + '-' + date[1] + '-' + date[0]
              item[keys[i]] = date
            }
          }
          this.$emit('setForm', { fieldName: this.inputId, item: item, index: this.index, parent: this.parent })
        }
        this.closeRef()
        this.updateIdbData()
      },
      updateIdbData () {
        console.log('updateIdbData')
        if ((this.type === 'simple') || this.select) {
          this.$emit('setForm', { fieldName: this.inputId, item: this.model, index: this.index, parent: this.parent })
        }
      },
      addToCatalog () {
        const hasEmptyFields = this.createFields.filter((item) => {
          return (item.value === null)
        })
        if (hasEmptyFields.length > 0) {
          this.$bvToast.toast('Заполните поля, необходимые для сохранения в справочник!', {
            title: 'Не заполнены обязательные поля',
            toaster: 'b-toaster-bottom-right',
            solid: true,
            appendToast: true
          })
        } else {
          this.$bvModal.msgBoxConfirm('Вы действительно хотите сохранить данные в справочник?', {
            okTitle: 'Да',
            cancelTitle: 'Нет',
            size: 'sm',
            buttonSize: 'sm',
            hideHeaderClose: true,
            centered: true
          }).then(value => {
            if (value === true) {
              let refsData = {}
              this.createFields.map((item) => {
                refsData[item.key] = item.value
              })
              this.postData({ data: refsData }).then(
                () => {
                  this.$bvToast.toast('Справочник сохранен!', {
                    title: 'Данные успешно добавлены',
                    toaster: 'b-toaster-bottom-right',
                    solid: true,
                    appendToast: true
                  })
                }
              )
            }
          }).catch(err => {
            console.log(err)
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .form-input-wrapper {
    position: relative !important;
    & .tooltips-wrapper {
      position: absolute;
      top: 36px;
      z-index: 10000;
      background-color: #ffffff;
      box-shadow: 0 4px 12px 0 rgb(0 0 0 / 30%);
      max-height: 200px;
      overflow-y: auto;
      overflow-x: hidden;
      & .fa-xmark {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
        &:hover {
          color: #000000;
        }
      }
    }
  }
</style>
